import { css } from '@emotion/core'

const setBackground = ({ backgroundUrl }) => css`
  background: url(${backgroundUrl}) no-repeat center;
`
const setDimensions = ({ dimensions }) => css`
  width: ${dimensions.width};
  height: ${dimensions.height};
`
const setColor = ({ colorCode }) => css`
  color: ${colorCode};
`
export { setBackground, setDimensions, setColor }
